import { connect } from 'react-redux'

import getDate from '../../../functions/getDate'
import sortPerformancesByDate from '../../../functions/sortPerformancesByDate'
import sortCinemas from '../../../functions/sortCinemas'
import Translation from '../../Translation/cont/Translation'
import TranslationShowtime from '../../Translation/cont/TranslationShowtime'
import TranslationDate from '../../Translation/cont/TranslationDate'
import getDateObj from '../../../functions/getDateObj'
import { ROUTES_DATA, TRANSLATION } from '../../../constants/state'
import toJS from '../../../containers/general/toJS'
import getMovieExtensions from '../../../functions/getMovieExtensions'
import FieldWrapper from '../FieldWrapper'
import { ErrorMessage, Field } from 'formik'

const mapStateToProps = (state, ownProps) => ({
    routeMovie: state.getIn([ROUTES_DATA, 'movies', 'items', ownProps.movieId]),
    currentLang: state.getIn([TRANSLATION, 'currentLang'])
})

const PlaySessionCheckboxes = ({movieData, openOverlay, performancesData, cliCinemas, clientCinemaId, setFieldValue, movieExtensionsEdited, routeMovie, currentLang, movieExtensionsItems, cliMovieRelevantSourceMovies}) => {
    const moviePerformanceIds = movieData.performances
    const moviePerformances = _.filter(performancesData, performance => {
        return _.contains(moviePerformanceIds, performance.id)
    })
    const moviePerformancesPerDateObject = {}
    const sortedCinemas = sortCinemas(clientCinemaId, cliCinemas)
    const movieExtension = {}

    moviePerformances.map(performance => {
        const {timeUtc} = performance
        
        if(!timeUtc) {
            return null
        }
        
        const date = getDate(timeUtc)
        if(_.has(moviePerformancesPerDateObject, date)) {
            if(!_.contains(moviePerformancesPerDateObject[date], performance)) {
                moviePerformancesPerDateObject[date].push(performance)
            }
        } else {
            moviePerformancesPerDateObject[date] = [performance]
        }
    })

    if(sortedCinemas.length === 1) {
        const cinemaId = sortedCinemas[0]
        getMovieExtensions(cinemaId, movieExtension, movieExtensionsItems, cliMovieRelevantSourceMovies)
        const cinemaMovieExtension = movieExtension[cinemaId]

        return <div>
            {cinemaMovieExtension && cinemaMovieExtension.hasOwnProperty('alternateLink') && <FieldWrapper label={<Translation id="movie_edit_replace_performances_with_alternate_link"/>} id="movieextension-alternatelink" classes="field-text gap-30">
                <Field name={"movieExtensionsItems." + cinemaMovieExtension.pk + '.alternateLink'} type="text" id="movieextension-alternatelink" className="text-small-light input-text-box" onChange={(e) => {

                    if(!_.contains(movieExtensionsEdited, cinemaMovieExtension.pk)) {
                        movieExtensionsEdited.push(cinemaMovieExtension.pk)
                    }
                    setFieldValue(e)
                }}/>
                <ErrorMessage name={"movieExtensionsItems." + cinemaMovieExtension.pk + '.alternateLink'} component="div" />
            </FieldWrapper>}
            {_.keys(moviePerformancesPerDateObject).sort().map((dateKey, dateIndex) => {
                const moviesPerDay = moviePerformancesPerDateObject[dateKey]
                const formattedDateKey = getDateObj(dateKey)
                const sortedPlaytimes = sortPerformancesByDate(moviesPerDay)
                
    
                return (
                    <fieldset key={dateIndex} className="playsessions-date">
                        <legend className="playsessions-date-legend title-large-color"><TranslationDate hasWeekday={true} string={formattedDateKey}/> </legend>
    
                        {sortedPlaytimes.map((performance, performanceIndex) => { 
                            const {timeUtc, theatreName, id} = performance
                            return ( 
                                !routeMovie || 
                                !routeMovie.hasOwnProperty('uri_list') || 
                                !routeMovie.uri_list.hasOwnProperty(currentLang) || 
                                !routeMovie.uri_list[currentLang]
                                ? (
                                    <div key={performanceIndex} className="playsessions-performance">
                                        <label key={performanceIndex}>
                                            <p><TranslationShowtime string={timeUtc}/> <Translation id="movie_sort_clock">Uhr</Translation></p>
                                            <p className="text-small-light">{theatreName}</p>
                                        </label>
                                    </div>
                                ) : (
                                    <div key={performanceIndex} className="playsessions-performance">
                                        <a className="movie-information-performance-link" title={'Zur Vorstellung'} href={routeMovie.uri_list[currentLang] + '?performance_id=' + id}  target="_blank">
                                            <label key={performanceIndex}>
                                                <p><TranslationShowtime string={timeUtc}/> <Translation id="movie_sort_clock">Uhr</Translation></p>
                                                <p className="text-small-light">{theatreName}</p>
                                            </label>
                                            <span className='screen-reader-text'>Zur Vorstellung</span>
                                        </a>
                                    </div>
                                )
                            )
                        })}
                    </fieldset>
                )
            })}
        </div>
    } else {
        return sortedCinemas.map((cinemaId, index) => {
            const cinemaData = cliCinemas[cinemaId]
            const {pk, nameDisplay} = cinemaData

            getMovieExtensions(cinemaId, movieExtension, movieExtensionsItems, cliMovieRelevantSourceMovies)
            const cinemaMovieExtension = movieExtension[cinemaId]

            return (
                <div key={index}>
                    <h2>{nameDisplay}</h2>
                    {cinemaMovieExtension && cinemaMovieExtension.hasOwnProperty('alternateLink') && <FieldWrapper label={<Translation id="movie_edit_replace_performances_with_alternate_link"/>} id="movieextension-alternatelink" classes="field-text gap-30">
                        <Field name={"movieExtensionsItems." + cinemaMovieExtension.pk + '.alternateLink'} type="text" id="movieextension-alternatelink" className="text-small-light input-text-box" onChange={(e) => {

                            if(!_.contains(movieExtensionsEdited, cinemaMovieExtension.pk)) {
                                movieExtensionsEdited.push(cinemaMovieExtension.pk)
                            }
                            setFieldValue(e)
                        }}/>
                        <ErrorMessage name={"movieExtensionsItems." + cinemaMovieExtension.pk + '.alternateLink'} component="div" />
                    </FieldWrapper>}
                    { _.keys(moviePerformancesPerDateObject).sort().map((dateKey, dateIndex) => {
                        const moviesPerDay = moviePerformancesPerDateObject[dateKey]
                        const formattedDateKey = getDateObj(dateKey)
                        const sortedPlaytimes = sortPerformancesByDate(moviesPerDay)

                       return (
                            <fieldset key={dateIndex} className="playsessions-date">
                                <legend className="playsessions-date-legend title-large-color"><TranslationDate hasWeekday={true} string={formattedDateKey}/></legend>
            
                                {sortedPlaytimes.map((performance, performanceIndex) => { 
                                    const {timeUtc, theatreName, cinemaId, attributes} = performance
                                    const bluePrice = _.find(attributes, (attribute) => {
                                        return attribute.id === 'schnaeppchen'
                                    }) ? ' blue-price' : ''

                                    if(cinemaId === pk) {
                                        return (
                                            !routeMovie || 
                                            !routeMovie.hasOwnProperty('uri_list') || 
                                            !routeMovie.uri_list.hasOwnProperty(currentLang) || 
                                            !routeMovie.uri_list[currentLang]
                                            ? (
                                                <div key={performanceIndex} className={"playsessions-performance" + bluePrice} onClick={() => openOverlay({performance:performance})}>
                                                    <div className='movie-information-performance-link'>
                                                        <label key={performanceIndex}>
                                                            <p><TranslationShowtime string={timeUtc}/> <Translation id="movie_sort_clock">Uhr</Translation></p>
                                                            <p className="text-small-light">{theatreName}</p>
                                                        </label>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div key={performanceIndex} className={"playsessions-performance" + bluePrice} onClick={() => openOverlay({routeMovie:routeMovie.uri_list[currentLang], performance:performance})}>
                                                    <div className='movie-information-performance-link'>
                                                        <label key={performanceIndex}>
                                                            <p><TranslationShowtime string={timeUtc}/> <Translation id="movie_sort_clock">Uhr</Translation></p>
                                                            <p className="text-small-light">{theatreName}</p>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        )
                                    }
                                })}
                            </fieldset>
                        )
                    })}
                </div>
            )
        }) 
    }
}

export default connect(mapStateToProps, null)(toJS(PlaySessionCheckboxes))